export const residenceFields = [
    {
        label: "Applicant Current Address *",
        state: "appCurEddress",
        apiName: 'borrower_current_address',
        required: true
    },
    {
        label:
            "Number Of Years At Current Address *",
        state: "curAddressYears",
        apiName: 'borrower_current_address_years',
        type: 'number',

        required: true

    },
    {
        label: "Ownership Of Residence *",
        state: "residenceOwnership",
        apiName: 'borrower_residence_ownership',
        required: true
        ,
        select: true,
        selectFields: [
            {
                name: 'RENTED',
                val: 'RENTED'
            },
            {
                name: 'SELF-OWNED',
                val: 'SELF-OWNED'
            },
            {
                name: 'FAMILY-OWNED',
                val: 'FAMILY-OWNED'
            }

        ]
    },
    {
        label: "Ownership In Name Of ",
        state: "ownerName",
        required: true,
        apiName: 'borrower_residence_ownership_name'
    },
    {
        label: "Relationship With Property Owner ",
        state: "ownerRelationship",
        apiName: 'borrower_residence_ownership_relation',
        required: true

    },
    {
        label: "Landlord Name (If Rented)",
        state: "landLordName",
        apiName: "borrower_residence_landlord_name",
        required: true

    },
    {
        label: "Rent (If rented)",
        state: "rented",
        apiName: "borrower_residence_rent",
        required: true
    },
    {
        label: "Contact Number *",
        state: "contactNumber",
        apiName: 'borrower_residence_mo_no',
        type: 'number',
        required: true
    },
    {
        label: "Permanent Address",
        state: "parmaAddress",
        apiName: "borrower_permanent_address",
        required: true
    },
    {
        label: "Number of years at Permanent Address",
        state: "parmaAddressYears",
        type: 'number',
        apiName: "borrower_permanent_address_years",
        required: true
    },
];

export const familyDetails1 = [
    {
        label: 'Name',
        state: 'family1Name',
    },
    {
        label: 'Relation',
        state: 'family1Relation'
    },
    {
        label: 'Age',
        state: 'family1Age',
        type: 'number',
    },
    {
        label: 'Occupation',
        state: 'family1Occupation'
    },
    {
        label: 'Monthly Income',
        type: 'number',
        state: 'family1MonthlyIncome'
    },
    {
        label: 'No. of loans taken',
        type: 'number',
        state: 'family1LoansTaken'
    },

]
export const familyDetails2 = [
    {
        label: 'Name',
        state: 'family2Name'
    },
    {
        label: 'Relation',
        state: 'family2Relation'
    },
    {
        label: 'Age',
        type: 'number',
        state: 'family2Age'
    },
    {
        label: 'Occupation',
        state: 'family2Occupation'
    },
    {
        type: 'number',
        label: 'Monthly Income',
        state: 'family2MonthlyIncome'
    },
    {
        type: 'number',
        label: 'No. of loans taken',
        state: 'family2LoansTaken'
    },

]
export const familyDetails3 = [
    {
        label: 'Name',
        state: 'family3Name'
    },
    {
        label: 'Relation',
        state: 'family3Relation'
    },
    {
        label: 'Age',
        type: 'number',
        state: 'family3Age'
    },
    {
        label: 'Occupation',
        state: 'family3Occupation'
    },
    {
        label: 'Monthly Income',
        type: 'number',
        state: 'family3MonthlyIncome'
    },
    {
        label: 'No. of loans taken',
        type: 'number',
        state: 'family3LoansTaken'
    },

]
export const familyDetails4 = [
    {
        label: 'Name',
        state: 'family4Name'
    },
    {
        label: 'Relation',
        state: 'family4Relation'
    },
    {
        label: 'Age',
        type: 'number',
        state: 'family4Age'
    },
    {
        label: 'Occupation',
        state: 'family4Occupation'
    },
    {
        label: 'Monthly Income',
        type: 'number',
        state: 'family4MonthlyIncome'
    },
    {
        label: 'No. of loans taken',
        type: 'number',
        state: 'family4LoansTaken'
    },

]
export const familyDetails5 = [
    {
        label: 'Name',
        state: 'family5Name'
    },
    {
        label: 'Relation',
        state: 'family5Relation'
    },
    {
        label: 'Age',
        type: 'number',
        state: 'family5Age'
    },
    {
        label: 'Occupation',
        state: 'family5Occupation'
    },
    {
        label: 'Monthly Income',
        type: 'number',
        state: 'family5MonthlyIncome'
    },
    {
        label: 'No. of loans taken',
        type: 'number',
        state: 'family5LoansTaken'
    },
]

export const businessDetails = [
    {
        label: 'Nature of business',
        state: 'natureOfBusiness',
        apiName: 'borrower_nature_of_business',
        select: true,
        selectFields: [
            "FINANCIAL INSTITUTE OTHER THAN NBFC",
            "NON-BANK FINANCIAL COMPANY",
            "FINANCIAL INTERMEDIATERIES",
            "MEDIA AND ENTERTAINMENT",
            "BANKING",
            "JEWELRY AND ORNAMENTS",
            "CHEMICALS",
            "ADVERTISING AND PROMOTION",
            "EDUCATION",
            "FREIGHT AND LOGISTICS",
            "REAL ESTATE AND BUILDER",
            "AUTOMOBILES",
            "CLOTH AND TEXTILES",
            "PHARMA AND MEDICINE",
            "ARCHITECT",
            "DOCTOR",
            "HOTEL AND HOSPITALITY",
            "IRON AND STEEL",
            "AGRICULTURE",
            "ACCOUNT CONSULTING",
            "CONTRACTOR AND FRANCHISEE",
            "ENGINEERING PRODUCTS",
            "IT AND SOFTWARE",
            "INSURANCE CIVIL CONTRACTOR",
            "TELECOM  HARDWARE AND DISTRIBUTION",
            "AGRICULTURE PROCESSING",
            "BPO AND KPO",
            "CEMENT MANUFACTURING STOCKING AND ALLIED ACTI",
            "ELECTRICAL ELECTRONICS MANUFACTURING SERVICE",
            "FMCG",
            "FURNITURE AND WOOD PRODUCTS",
            "IT HARDWARE AND PERIPHERALS",
            "NATURAL RESOURCES RELATED",
            "PAPER PRODUCTS AND ALLIED ACTIVITIES",
            "PLASTICS AND  ALLIED ACTIVITIES",
            "PUBLISHING AND PRINT MEDIA",
            "RETAIL SHOPS AND PROVISIONS RELATED",
            "RUBBER INDUSTRY  AND ALLIED PRODUCTS",
            "SHIPPING INDUSTRY",
            "OTHERS",
        ]
    },
    {
        label: 'Name of business',
        state: 'nameOfBusiness',
        apiName: 'borrower_business_name'

    },
    {
        label: 'Business Address',
        state: 'addressOfBusiness',
        apiName: 'borrower_business_address'
    },
    {
        label: 'Ownership of business permises (Owned/Rented)',
        state: 'ownershipOfBusiness',
        apiName: 'business_ownership'
    },
    {
        label: 'How long business has been running from current address?',
        type: 'number',
        state: 'businessAddressDuration',
        apiName: 'business_current_address_years'
    },
    {
        label: 'Total business vintage',
        state: 'businessVintage',
        apiName: 'total_business_vintage'
    },
    {
        label: "Does owner has any business registration proof?",
        state: 'businessRegistrationProofExist',
        select: true,
        apiName: 'business_registration_proof',
        selectFields: [
            {
                name: 'Yes',
                val: "Yes"
            },
            {
                name: 'No',
                val: "No"
            },
        ]
    },
    {
        label: "Previous address(If current is applicable for less than a year)",
        state: 'prevAddress',
        apiName: 'business_previous_address'
    },
    {
        label: "Monthly Sales",
        type: 'number',
        state: 'monthlySale',
        apiName: 'monthly_sale'
    },
    {
        label: "Monthly Profit",
        type: 'number',
        state: 'monthlyProfit',
        apiName: 'monthly_profit'
    },
    {
        label: "Loan required amount",
        type: 'number',
        state: 'loanReqAmount',
        apiName: 'borrower_requested_loan_amt'
    },
    {
        label: "Purpose of loan",
        state: 'loanPurpose',
        apiName: 'borrower_loan_purpose',
        select: true,
        selectFields: [
            "CATTLE PURCHASE",
            "CATTLE SHED CONSTRUCTION",
            "CATTLE PURCHASE & CATTLE SHED CONSTRUCTION",
            "HOME RENOVATION",
            "HOME CONSTRUCTION",
            "FAMILY FUNCTION",
            "EDUCATION",
            "MEDICAL PURPOSE",
            "DEBT CONSOLIDATION"
        ]
    },
    {
        label: 'Affordable EMI',
        type: 'number',
        state: 'affordableEMI',
        apiName: 'affordable_emi'
    }
]

export const referenceCheck_1 = [
    {
        label: 'Name',
        state: 'ref1name',
        apiName: 'reference_name_1'
    },
    {
        label: 'Relationship to the applicant',
        state: 'ref1Relation',
        apiName: 'reference_relationship_1'
    },
    {
        label: 'What does the customer do?',
        state: 'ref1Occupation',
        apiName: 'reference_customer_do_1'
    },
    {
        label: 'Contact Number',
        state: 'ref1Number',
        type: 'number',

        apiName: 'reference_number_1'
    },

    {
        label: 'What is your current address (to confirm with application form).',
        state: 'ref1CurAddress',
        apiName: 'reference_customer_current_address_1'
    },
    {
        label: 'Since How many Years you are staying at current address?',
        state: 'ref1AddressDuration',
        apiName: 'reference_customer_current_address_years_1'
    },
    {
        label: 'Is this your permanent address. (If No what is your permanent add.)',
        state: 'ref1PermAddress',
        apiName: 'reference_customer_permanent_address_1'
    },
]

export const referenceCheck_2 = [
    {
        label: 'Name',
        state: 'ref2name',
        apiName: 'reference_name_2'
    },
    {
        label: 'Relationship to the applicant',
        state: 'ref2Relation',
        apiName: 'reference_relationship_2'
    },
    {
        label: 'What does the customer do?',
        state: 'ref2Occupation',
        apiName: 'reference_customer_do_2'
    },
    {
        label: 'Contact Number',
        state: 'ref2Number',
        type: 'number',

        apiName: 'reference_number_2'
    },
    {
        label: 'What is your current address (to confirm with application form).',
        state: 'ref2CurAddress',
        apiName: 'reference_customer_current_address_2'
    },
    {
        label: 'Since How many Years you are staying at current address?',
        state: 'ref2AddressDuration',
        apiName: 'reference_customer_current_address_years_2'
    },
    {
        label: 'Is this your permanent address. (If No what is your permanent add.)',
        state: 'ref2PermAddress',
        apiName: 'reference_customer_permanent_address_2'
    },
]